import mitt from 'mitt';

export const emitterProject = mitt();
export const stateProject = {
  pendingProyecto: null,
  deboVolverACurso : false,
  deboVolverACursoDesdeProject : false,
  projectCurso:false,
  fromCurso : true,
  volverAProject : true,
  cursoIdOrigen:null,
  origenNavegacion:null,
};